<div class="content">
  <div #target>
    <ng-template footer-content></ng-template>
  </div>
</div>
